import * as React from 'preact/compat'
import cn from 'classnames'
import type { JSXInternal } from 'preact/src/jsx'
import Api from '../../../api'
import type { DialogComponentPropTypes } from '../AuthDialog'
import styles from '../../../../css/auth.pcss.json'
import formCss from '../../../../css/form.pcss.json'
import buttonsCss from '../../../../css/buttons.pcss.json'
import { loadStylesheet } from '../../../common/helpers'

interface StateTypes {
  isSending: boolean,
  error: string | null,
  success: boolean
}

export default class PageSgActivate extends React.Component<DialogComponentPropTypes, StateTypes> {

  state: StateTypes = {
    success: false,
    isSending: false,
    error: null
  }

  form = React.createRef<HTMLFormElement>()

  public componentWillMount() {
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('form')
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('buttons')
  }

  public componentDidMount() {
    if (this.code) {
      this.form.current.requestSubmit()
    }
    history.replaceState('', document.title, window.location.pathname + window.location.search)
  }

  activate = (event: JSXInternal.TargetedEvent<HTMLFormElement>) => {
    event.preventDefault()

    this.setState({
      isSending: true,
      error: null
    })

    const formData = new FormData(event.currentTarget)

    Api.post({
      url: 'auth/activate',
      body: formData
    })
      .then(result => {
        if (result.success) {
          this.setState({
            success: true
          })
          ym(36906115, 'reachGoal', 'register')
          window.location.reload()
          return
        }
        this.setState({
          isSending: false,
          error: result.error
        })
      })
      .catch(() => {
        this.setState({
          isSending: false,
          error: 'Произошла непредвиденная ошибка'
        })
      })
  }

  get code() {
    return window.activationCode ?? null
  }

  render() {
    const { isSending, error, success } = this.state

    if (success) {
      return <>
        <div className={styles['auth-header']}>
          <h1 style='color: var(--green)'>Ура! Аккаунт активирован!</h1>
          <p>Сейчас страница перезагрузится и ты войдёшь на сайт под своим аккаунтом.</p>
          <p>Если этого не произошло — перезагрузи страницу.</p>
        </div>
      </>
    }

    return <>
      <div className={styles['auth-header']}>
        <h1>Активация аккаунта</h1>
      </div>
      <form
        onSubmit={this.activate}
        ref={this.form}
        style='display: flex; flex-direction: column; align-items: center;'
      >
        <input
          type="text"
          name="code"
          placeholder="Код активации из письма"
          value={this.code}
          required
          className={cn(formCss['input'], {
            [formCss['input--error']]: error
          })}
          autocomplete="one-time-code"
        />
        <p
          className={formCss['error-hint']}
          style={{ opacity: error ? 1 : 0, width: '100%' }}
        >{error || 'Нет ошибок'}</p>
        <button
          type="submit"
          disabled={isSending}
          className={buttonsCss['primary']}
          style='min-width: 170px'
        >
          Активировать
        </button>
      </form>
    </>
  }
}
